export default __webpack_public_path__ + "static/media/noImage.c1745f31.png";